<template>
  <common-dialog ref="dialog" :title="title" width="1100px" :in-dialog="inDialog">
    <list ref="list"></list>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  mixins: [listDialogMixins],
  components: {
    commonDialog,
    list,
  },
  props: {
    title: {
      type: String,
      default: "应收明细账",
    },
  },
};
</script>